(function () {
    function init() {
        var root = document.querySelector('.catalog-slideshow');
        if (!root) { return; }
        var track = root.querySelector('.slideshow-track');
        var viewport = root.querySelector('.slideshow-viewport');
        var prevBtn = root.querySelector('.slideshow-prev');
        var nextBtn = root.querySelector('.slideshow-next');
        if (!track || !viewport || !prevBtn || !nextBtn) { return; }

        var index = 0;
        var lastPage = parseInt(root.getAttribute('data-last-page'), 10) || 1;
        var loadedPage = parseInt(root.getAttribute('data-current-page'), 10) || 1;
        var ajaxBase = root.getAttribute('data-ajax-base') || '';
        var ajaxParams = root.getAttribute('data-ajax-params') || '';
        var fetching = false;

        function slideCount() { return track.querySelectorAll('.slideshow-slide').length; }

        function render() {
            track.style.transform = 'translateX(' + (-index * 100) + '%)';
            prevBtn.classList.toggle('slideshow-nav--off', index <= 0);
            nextBtn.classList.toggle('slideshow-nav--off', (index >= slideCount() - 1) && (loadedPage >= lastPage));
        }

        function fetchNextPage(cb) {
            if (fetching || loadedPage >= lastPage) { if (cb) { cb(); } return; }
            fetching = true;
            var page = loadedPage + 1;
            var url = ajaxBase + '/page/' + page + '/' + (ajaxParams ? ('?' + ajaxParams) : '');
            fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    if (data && data.render) {
                        track.insertAdjacentHTML('beforeend', data.render);
                        loadedPage = parseInt(data.page, 10) || page;
                        if (data.has_more === false) { lastPage = loadedPage; }
                    }
                    fetching = false;
                    render();
                    if (cb) { cb(); }
                })
                .catch(function () { fetching = false; if (cb) { cb(); } });
        }

        function prefetch() {
            if (loadedPage < lastPage && index >= slideCount() - 2 && !fetching) { fetchNextPage(); }
        }

        function goTo(target) {
            if (target < 0) { return; }
            if (target > slideCount() - 1) {
                if (loadedPage < lastPage) {
                    fetchNextPage(function () { if (target <= slideCount() - 1) { index = target; render(); prefetch(); } });
                }
                return;
            }
            index = target;
            render();
            prefetch();
        }

        prevBtn.addEventListener('click', function () { goTo(index - 1); });
        nextBtn.addEventListener('click', function () { goTo(index + 1); });

        document.addEventListener('keydown', function (e) {
            var tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
            if (tag === 'input' || tag === 'textarea' || tag === 'select' || (e.target && e.target.isContentEditable)) { return; }
            if (e.key === 'ArrowLeft' || e.keyCode === 37) { goTo(index - 1); }
            else if (e.key === 'ArrowRight' || e.keyCode === 39) { goTo(index + 1); }
        });

        var startX = null;
        viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        viewport.addEventListener('touchend', function (e) {
            if (startX === null) { return; }
            var dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) { goTo(index + (dx < 0 ? 1 : -1)); }
            startX = null;
        }, { passive: true });

        render();
        prefetch();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
